export enum MIXPANEL_EVENTS {
    LOGIN_SUCCESS = 'Login Successful',
    LOGIN_FAILED = 'Login Failed',
    SIGN_UP_BUTTON = 'Sign Up Button Click Success',
    EMAIL_CONFIRMED = 'Sign Up Confirmation',
    CREATE_ANNNUAL_REPORT_BUTTON_CLICK = 'Create Annual Report Button Click',
    COMPANY_CREATION_BUTTON_CLICK_IN_REPORT = 'Company Creation Button Click In Report',
    COMPANY_SAVED_IN_REPORT = 'Company Saved In Report',
    ACCOUNTING_BASIS_SELECTION = 'Accounting Basis Selection',
    Annual_REPORT_TEMPLATE_SELECTION = 'Annual Report Template Selection',
    GENERAL_INFORMATION_TIME_SPENT_TILL_COMPLETION = 'General Information Time Spent Till Completion',
    UPLOAD_SHEET_TIME_SPENT_TILL_COMPLETION = 'Upload Sheet Time Spent Till Completion',
    GROUPING_MASKING = 'Grouping Masking opened',
    ACCOUNT_MAPPING_TIME_SPENT_TILL_COMPLETION = 'Account Mapping Time Spent Till Completion',
    CASH_FLOW_TIME_SPENT_TILL_COMPLETION = 'Cash Flow Time Spent Till Completion',
    NOTES_TIME_SPENT_TILL_COMPLETION = 'Notes Time Spent Till Completion',
    AOP_TIME_SPENT_TILL_COMPLETION = 'AOP Time Spent Till Completion',
    EMS_TIME_SPENT_TILL_COMPLETION = 'EMS Time Spent Till Completion',
    FAS_TIME_SPENT_TILL_COMPLETION = 'FAS Time Spent Till Completion',
    ADJ_AND_REC_TIME_SPENT_TILL_COMPLETION = 'Adjustments And Reclasses Time Spent Till Completion',
    COMPLEMENTARY_REPORTS_TIME_SPENT_TILL_COMPLETION = 'Complementary Reports Time Spent Till Completion',
    FINISH_AND_PRINT_TIME_SPENT_TILL_COMPLETION = 'Finish and Print Time Spent Till Completion',
    UPLOAD_SHEET_SUCCESS = 'Upload Sheet Success',
    DEFAULT_PRINT_BUTTON_CLICK = 'Default Print Button Click',
    PDF_TRON_PRINT_BUTTON_CLICK = 'PDF Tron Print Button Click',
    EXPORT_TO_WORD_BUTTON_CLICK = 'Export To Word Button Click',
    EXPORT_TO_EXCEL_BUTTON_CLICK = 'Export To Excel Button Click',
    SECURE_SHARE_BUTTON_CLICK = 'Secure Share Button Click',
    COMPANY_VALUATION_SIDE_NAV_CLICK = 'Company Valuation Side Nav Link clicked',
    COMPANY_VALUATION_ANNOUNCEMENT_NAVIGATION_BUTTON_CLICK = 'Company Valuation navigation button in announcement clicked',
    COMPANY_VALUATION_EXAMPLE_REPORT_DOWNLOADED = 'Company Valuation Example Report Downloaded',
    COMPANY_VALUATION_REPORT_ORDER_BUTTON_CLICK = 'Company Valuation Report Order Button Clicked',
    COMPANY_VALUATION_TRY_OUT_ANNOUNCEMENT_BUTTON_CLICK = 'Company Valuation Report announcement button clicked',
}
